import type { DomainConfigItem } from './domainConfig'

export function buildDomainLists(
  domainsData: Record<string, Array<{ name: string; extras?: any }>> | undefined,
  config: DomainConfigItem[]
): Record<string, string[]> {
  if (!domainsData) return {}

  const withGeneralActivityAliases = (values: string[]): string[] => {
    const normalized = values.map(v => String(v ?? '').trim()).filter(Boolean)
    const hasY = normalized.includes('DATA Y DESARROLLO')
    const hasAmp = normalized.includes('DATA & DESARROLLO')
    if (!hasY && !hasAmp) return normalized
    if (!hasY) normalized.push('DATA Y DESARROLLO')
    if (!hasAmp) normalized.push('DATA & DESARROLLO')
    return Array.from(new Set(normalized))
  }

  return config.reduce<Record<string, string[]>>((acc, item) => {
    const base = domainsData[item.alias]?.map(d => d.name) ?? []
    acc[item.listKey] =
      item.listKey === 'generalActivityList'
        ? withGeneralActivityAliases(base)
        : base
    return acc
  }, {})
}
